import { Link } from 'react-router-dom';
import {
  ArrowRightIcon,
  ChevronRightIcon,
  FireIcon,
} from '@heroicons/react/24/outline';
import { HomeDropsScrollRail } from '../HomeDropsScrollRail';
import { HomeLazySection } from '../HomeLazySection';
import { HomeTrustStrip } from '../HomeTrustStrip';
import { HOME_TRUST_BADGES } from '../homeContent';
import { HOME_POPULAR_DROPS } from '../homePopularDrops';

export function HomePopularSection() {
  return (
    <HomeLazySection
      id="popular-drops"
      lazy={false}
      className="relative py-14 md:py-20 bg-[#0c0e1a] text-white overflow-hidden"
      placeholderMinHeight="420px"
    >
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_-10%,rgba(99,102,241,0.35),transparent)]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#0c0e1a] to-transparent"
        aria-hidden
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold border border-white/10">
              <FireIcon className="h-4 w-4 text-orange-400" />
              Style inspiration
            </div>
            <h2 className="mt-4 text-3xl md:text-5xl font-extrabold tracking-tight">
              Curated looks to explore.
            </h2>
            <p className="mt-3 text-white/70 max-w-xl">
              Scroll the rail for style inspiration — tap through to the shop for live listings and
              prices.
            </p>
          </div>

          <Link
            to="/shop"
            className="inline-flex items-center justify-center px-5 py-3 rounded-full bg-white text-slate-900 text-sm font-semibold shadow-sm hover:shadow-md transition-all w-full md:w-auto"
          >
            Shop all designs
            <ArrowRightIcon className="ml-2 h-4 w-4" />
          </Link>
        </div>

        <div className="mt-5 flex items-center justify-between gap-3 text-sm">
          <p className="text-white/60">
            <span className="font-bold text-white">{HOME_POPULAR_DROPS.length}</span> looks to
            explore · swipe or drag
          </p>
          <span className="hidden sm:inline-flex items-center gap-1 text-white/50 text-xs font-semibold uppercase tracking-wide">
            Scroll
            <ChevronRightIcon className="h-4 w-4" />
          </span>
        </div>
      </div>

      <div className="relative mt-8 md:mt-10">
        <HomeDropsScrollRail drops={HOME_POPULAR_DROPS} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <HomeTrustStrip badges={HOME_TRUST_BADGES} variant="dark" />
      </div>
    </HomeLazySection>
  );
}
